import { BackgroundPaths } from './background-paths';
import valinorLogo from './Logo_design_for_VALI-removebg-preview(1).png';

export function DemoBackgroundPaths() {
  return (
    <BackgroundPaths
      title="built for world's hardest terrain"
      logoSrc={valinorLogo}
      logoAlt="Valinor Dynamics"
      videoSrc="/assets/autonomous-rover-wildflower.mp4"
    />
  );
}
